import * as Yup from 'yup';

export const calibrationValidationSchema = Yup.object().shape({
  calibration_name: Yup.string().required('fillField'),
  calibration_type: Yup.string().required('fillField'),
  data_type: Yup.string().required('fillField'),
  quantity_per_liter: Yup.number()
    .integer('notDecimalInt')
    .min(0, 'positiveInt')
    .when('calibration_type', {
      is: 'counter',
      then: (schema) => schema.required('fillField'),
      otherwise: (schema) => schema.notRequired(),
    }),
  method: Yup.string().when('calibration_type', {
    is: 'counter',
    then: (schema) => schema.required('fillField'),
    otherwise: (schema) => schema.notRequired(),
  }),
  interpolationData: Yup.array()
    .of(
      Yup.object().shape({
        decimal: Yup.number()
          .required('validationList.fillField')
          .min(0, 'validationList.positiveInt'),
        integer: Yup.number()
          .required('validationList.fillField')
          .integer('validationList.notDecimalInt')
          .min(0, 'validationList.positiveInt'),
      }),
    )
    .when('calibration_type', {
      is: 'interpolation',
      then: (schema) => schema.min(0, 'Добавьте хотя бы одну пару значений'),
      otherwise: (schema) => schema.notRequired(),
    }),
});
